import { useData } from '../../store/data';

type Cls = 'need' | 'want';

/** Gợi ý theo tên — chỉ những danh mục rõ nghĩa; còn lại để người dùng tự chọn. */
const NEED_HINTS = ['ăn uống', 'y tế', 'hóa đơn', 'hoá đơn', 'bảo hiểm', 'nhà cửa', 'giáo dục', 'di chuyển', 'điện', 'nước', 'học phí'];
const WANT_HINTS = ['giải trí', 'mua sắm', 'du lịch', 'cà phê', 'quà'];

export const suggestClass = (name: string): Cls | undefined => {
  const n = name.toLowerCase();
  if (NEED_HINTS.some(h => n.includes(h))) return 'need';
  if (WANT_HINTS.some(h => n.includes(h))) return 'want';
  return undefined;
};

/** Danh mục chi chưa từng được gán nhãn Thiết yếu/Mong muốn (thiếu nhãn = tính là Mong muốn). */
export const useUnclassified = () => {
  const cats = useData(s => s.data.expenseCategories);
  return cats.filter((c: any) => c.budgetClass !== 'need' && c.budgetClass !== 'want');
};
